import type { FC, ReactNode } from 'react'

import { Star } from '@/components/generals/star'
import { VelocityMarquee } from '@/components/motion/velocity-marquee'

const TEAL_TAPE = ['Communication', 'Marketing', 'Events', 'Social media', 'Brand content', 'Creativity']
const ORANGE_TAPE = ['Ideas', 'Strategy', 'Storytelling', 'Community', 'Launches', 'Energy']

const TAPE_TEXT = 'font-heading text-4xl font-extrabold uppercase tracking-tight md:text-6xl'

// Two crossed tapes whose text speeds up and reverses with the scroll.
export const MarqueeTapes: FC = (): ReactNode => {
    return (
        <div aria-hidden='true' className='relative z-10 py-14 md:py-20'>
            <div className='relative -mx-[5vw] w-[110vw] -rotate-3 bg-secondary py-4 text-white shadow-[0_20px_40px_-25px_rgba(0,0,0,0.6)] md:py-6'>
                <VelocityMarquee
                    items={TEAL_TAPE}
                    baseVelocity={-70}
                    itemClassName={TAPE_TEXT}
                    separator={<Star className='size-6 shrink-0 text-accent md:size-9' />}
                />
            </div>

            <div className='relative -mx-[5vw] -mt-6 w-[110vw] rotate-2 bg-primary py-4 text-primary-foreground md:-mt-10 md:py-6'>
                <VelocityMarquee
                    items={ORANGE_TAPE}
                    baseVelocity={70}
                    itemClassName={TAPE_TEXT}
                    separator={<Star className='size-6 shrink-0 md:size-9' />}
                />
            </div>
        </div>
    )
}
